// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export default {
    improvePassword: 'To improve your password:',
    passwordTooShort: 'Make the password longer.',
    lettersLowerCase: 'Use at least one lower-case character.',
    lettersUpperCase: 'Use at least one upper-case character.',
    numbers1: 'Use at least one number.',
    numbers3: 'Use at least three numbers.',
    specialChar1: 'Use at least one special character (for example: !, @, #, $, % ,^, &, *, ?, _, ~).',
    specialChar2: 'Use at least two special characters (for example: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Use both upper and lower-case characters.',
    comboLettersAndNumbers: 'Use both numbers and characters.',
    comboLettersNumbersSpecial: 'Use numbers, characters and special characters.',
    yourPasswordIsStrong: 'You can make it even stronger by increasing its length.',
    passwordStrength: 'The password strength is %%strength%%.',
    strengthStrong: 'STRONG',
    strengthWeak: 'WEAK',
    strengthMedium: 'MEDIUM',
    hidePassword: 'Hide password',
    showPassword: 'Show password',
    generateButton: 'Generate',
    generateButtonHint: 'Generate strength password',
};



// WEBPACK FOOTER //
// ./components/FormFieldPassword/locale/en-US.js